module.exports = __webpack_public_path__ + "img/icon-home-grey.893afcf4.svg";